// src/redux/slices/jewelleryPlan/quoteSlice.js

import { createSlice } from "@reduxjs/toolkit";
import {
  checkBalanceThunk,
  createBalanceQuoteThunk,
  getQuoteThunk,
  validateQuoteThunk,
  getPlanQuotesThunk,
} from "../../thunks/jewelleryPlan/quoteThunks";

const initialState = {
  // Balance check data
  balance: null,
  balanceLoading: false,

  // Quotes
  quotes: [],
  selectedQuote: null,
  planQuotes: [],

  // Validation
  validation: null,

  // Loading states
  loading: false,
  createLoading: false,

  // Errors
  error: null,
  balanceError: null,
};

const quoteSlice = createSlice({
  name: "quotes",
  initialState,
  reducers: {
    clearBalance: (state) => {
      state.balance = null;
      state.balanceError = null;
    },
    clearSelectedQuote: (state) => {
      state.selectedQuote = null;
      state.validation = null;
    },
    clearQuoteError: (state) => {
      state.error = null;
      state.balanceError = null;
    },
    updateSelectedKarat: (state, action) => {
      if (state.balance) {
        state.balance.selectedKarat = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // ==========================================
      // Check Balance
      // ==========================================
      .addCase(checkBalanceThunk.pending, (state) => {
        state.balanceLoading = true;
        state.balanceError = null;
      })
      .addCase(checkBalanceThunk.fulfilled, (state, action) => {
        state.balanceLoading = false;
        state.balance = action.payload.data;
      })
      .addCase(checkBalanceThunk.rejected, (state, action) => {
        state.balanceLoading = false;
        state.balanceError = action.payload;
      })

      // ==========================================
      // Create Balance Quote
      // ==========================================
      .addCase(createBalanceQuoteThunk.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createBalanceQuoteThunk.fulfilled, (state, action) => {
        state.createLoading = false;
        state.quotes.unshift(action.payload.data);
        state.selectedQuote = action.payload.data;
      })
      .addCase(createBalanceQuoteThunk.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
      })

      // ==========================================
      // Get Quote
      // ==========================================
      .addCase(getQuoteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuoteThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedQuote = action.payload.data;
      })
      .addCase(getQuoteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==========================================
      // Validate Quote
      // ==========================================
      .addCase(validateQuoteThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(validateQuoteThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.validation = action.payload.data;
      })
      .addCase(validateQuoteThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==========================================
      // Get Plan Quotes
      // ==========================================
      .addCase(getPlanQuotesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlanQuotesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.planQuotes = action.payload.data;
      })
      .addCase(getPlanQuotesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearBalance,
  clearSelectedQuote,
  clearQuoteError,
  updateSelectedKarat,
} = quoteSlice.actions;

export default quoteSlice.reducer;
